import React from 'react';
import { useTranslation } from 'react-i18next';
import { Stack, Typography } from '@mui/material';
import AuthLayout from 'layouts/AuthLayout';
import VerifyOtpForm from './VerifyOtpForm';

const VerifyOtp = () => {
  const { t } = useTranslation(['verifyOtp']);
  return (
    <AuthLayout title="Verify OTP | Interswitch">
      <Stack sx={{ mb: 5 }}>
        <Typography variant="h4" gutterBottom>
          {t('verifyOtp:title')}
        </Typography>
        <Typography sx={{ color: 'text.secondary' }}>{t('verifyOtp:subtitle')}</Typography>
      </Stack>
      <VerifyOtpForm />
    </AuthLayout>
  );
};

export default VerifyOtp;
